import * as rsuite from 'rsuite';
import { HiPlusCircle } from "react-icons/hi";

// The page-title bar + "افزودن" (add) button used at the top of every
// CRUD list page. Shared across pages so the responsive desktop/mobile
// button layout only has to be maintained in one place.
const CrudPageHeader = ({ title, onAdd, addLabel = "افزودن" }) => (
    <div className="sticky top-0 z-20 bg-white">
        <rsuite.Grid fluid className="h-[20%] sm:h-[13%] pb-5">
            <rsuite.Row className="bg-gray-100 m-2 rounded-lg h-1/2 sm:h-full flex items-center px-1 sm:px-5">
                <rsuite.Col xs={12}>
                    <p>{title}</p>
                </rsuite.Col>
                {onAdd && (
                    <rsuite.Col xs={12} className="justify-end items-end hidden sm:flex p-5">
                        <rsuite.Button onClick={onAdd} color="cyan" appearance="primary" size="lg">
                            <HiPlusCircle className="me-3" />
                            {addLabel}
                        </rsuite.Button>
                    </rsuite.Col>
                )}
            </rsuite.Row>

            {onAdd && (
                <rsuite.Row className="bg-gray-100 m-2 rounded-lg h-1/2 flex items-center px-1 sm:hidden">
                    <rsuite.Col xs={24} className="flex justify-end items-end">
                        <rsuite.Button onClick={onAdd} color="cyan" appearance="primary" size="lg">
                            <HiPlusCircle className="me-3" />
                            {addLabel}
                        </rsuite.Button>
                    </rsuite.Col>
                </rsuite.Row>
            )}
        </rsuite.Grid>
    </div>
);

export default CrudPageHeader;
